import { TranslateHook } from '../../../modules/journey-canvas/utility/TypeDefs';

export interface ISelectProps {
  name: string;
  value: number | string;
}

/**
 * @method getNumbersList
 * @param limit
 * @returns list containing numbers from 0-limit
 */
const getNumbersList = (limit: number) => [...Array(limit)].map((a, b) => (b <= 9 ? `0${b}` : b));

/**
 * @method getTimeValues
 * @description converts the list from getNumbersList func to {value: number, name: string} format
 * @param limit
 * @returns finalList
 */
export const getTimeValues = (limit: number) => {
  const list = getNumbersList(limit);
  const finalList: ISelectProps[] = [];
  list.forEach((el) => finalList.push({ value: el, name: el.toString() }));
  return finalList;
};

export type weekType = {
  name: string,
  sign: string,
  index: number,
  flag: boolean,
};

export const week = [
  {
    name: 'month_component.txt_sunday',
    sign: 'S',
    index: 1,
    flag: false
  },
  {
    name: 'month_component.txt_monday',
    sign: 'M',
    index: 2,
    flag: true
  },
  {
    name: 'month_component.txt_tueday',
    sign: 'T',
    index: 3,
    flag: true
  },
  {
    name: 'month_component.txt_wedday',
    sign: 'W',
    index: 4,
    flag: false
  },
  {
    name: 'month_component.txt_thursday',
    sign: 'T',
    index: 5,
    flag: false
  },
  {
    name: 'month_component.txt_friday',
    sign: 'F',
    index: 6,
    flag: false
  },
  {
    name: 'month_component.txt_satday',
    sign: 'S',
    index: 7,
    flag: false
  }
];

/**
 * @method weekDaysTxtHandler
 * @description converts the weeksDays selected to shorthand text
 * @param arr
 * @returns string text
 */
export const weekDaysTxtHandler = (arr: string[], translate: TranslateHook) => {
  const weekDay = [translate('month_component.txt_monday'), translate('month_component.txt_tueday'), translate('month_component.txt_wedday'), translate('month_component.txt_thursday'), translate('month_component.txt_friday')];
  const weekend = [translate('month_component.txt_satday'), translate('month_component.txt_sunday')];
  if (arr.length < 7 && weekDay.every((i) => arr.includes(i)) && !weekend.some((i) => arr.includes(i))) {
    return (String(translate('canvas_utility.txt_on_weekday')));
  }
  if (weekend.every((i) => arr.includes(i)) && !weekDay.some((i) => arr.includes(i))) {
    return (String(translate('canvas_utility.txt_on_weekend')));
  }
  if (arr.length === 7) {
    return (String(translate('canvas_utility.txt_everyday')));
  }
  const sortedDays = sortDays(arr, translate);
  return sortedDays.toString().replaceAll(',', ', ');
};

/**
 * @method monthDaysTxtHandler
 * @description converts the monthDays selected to shorthand text
 * @param arg
 * @returns string text
 */
export const monthDaysTxtHandler = (arg: string, translate: TranslateHook) => {
  switch (arg) {
    case '2':
      return String(translate('canvas_utility.txt_the_second'));
    case '3':
      return String(translate('canvas_utility.txt_the_third'));
    case '4':
      return String(translate('canvas_utility.txt_the_fourth'));
    default:
      return String(translate('canvas_utility.txt_the_first'));
  }
};

/**
 * @method isJSONHandler
 * @description checks whether the entered payload is in JSON format
 * @param str
 * @returns boolean
 */
export const isJSONHandler = (str: string) => {
  if (str.length) {
    try {
      return JSON.parse(str) && !!str;
    } catch (e) {
      return false;
    }
  }
  return null;
};

/**
 * @method dateToUtcConversion
 * @description converts the local date to utc number (can be used for validating purposes)
 * @param year
 * @param month
 * @param date
 * @param hour
 * @param minute
 * @returns Utc Converted date
 */
export const dateToUtcConversion = (year: number, month: number, date: number, hour: number, minute: number,) => (Date.UTC(year, month, date, hour, minute));

/**
 * @method getUtcDate
 * @description converts separate components of local date and time to utc date and time (can be used for payload purposes)
 * @param getDate
 * @param hour
 * @param minute
 * @returns utcDate
 * @returns utcHour
 * @returns utcMinute
 */
export const getUtcDate = (getDate: Date | null, hour: number | string, minute: number | string) => {
  const localDate = `${getDate?.toString().substring(0, 15)} ${hour.toString()}:${minute.toString()}${getDate?.toString().substring(21,)}`;
  const newUtcDate = new Date(localDate);
  return {
    utcDate: `${newUtcDate.getUTCDate().toString().padStart(2, '0')}/${(newUtcDate.getUTCMonth() + 1).toString().padStart(2, '0')}/${newUtcDate.getUTCFullYear()}`,
    utcHour: newUtcDate.getUTCHours(),
    utcMinute: newUtcDate.getUTCMinutes()
  };
};

/**
 * @method sortDays
 * @description sort the weekDays of an array
 * @param days
 * @returns sorted array
 */
const sortDays = (days: string[], translate: TranslateHook) => {
  const arr = ['', '', '', '', '', '', ''];
  days.forEach((day) => {
    if (day === 'Sunday') arr[0] = String(translate('week_component.txt_sunday'));
    if (day === 'Monday') arr[1] = String(translate('week_component.txt_monday'));
    if (day === 'Tuesday') arr[2] = String(translate('week_component.txt_tueday'));
    if (day === 'Wednesday') arr[3] = String(translate('week_component.txt_wedday'));
    if (day === 'Thursday') arr[4] = String(translate('week_component.txt_thursday'));
    if (day === 'Friday') arr[5] = String(translate('week_component.txt_friday'));
    if (day === 'Saturday') arr[6] = String(translate('week_component.txt_satday'));
  });
  return arr.filter((str) => str !== '');
};

/**
 * @method maxScheduleVal
 * @param arg
 * @returns maximum value of the selected schedule type
 */
export const maxScheduleVal = (arg: undefined | string) => {
  switch (arg) {
    case 'hourly':
      return 23;
    case 'daily':
      return 31;
    case 'weekly':
      return 99;
    case 'monthly':
      return 12;
    default:
      return 1;
  }
};
